export default {
  loginRequest(state, user) {
    state.status = { loggingIn: true }
    state.user = user
  },
  loginSuccess(state, { user, token }) {
    state.status = { loggedIn: true }
    state.user = user
    state.token = token
  },
  loginFailure(state) {
    state.status = {}
    state.user = null
    state.token = null
  },
  logout(state) {
    state.status = {}
    state.user = null
    state.token = null
  },
  saveIdentification(state, identification) {
    state.identification = identification
  },
  saveIdentificationType(state, identificationType) {
    state.identificationType = identificationType
  }
}
